var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgClose = function SvgClose(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 42 42",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m30.087 9.337 2.075 2.075-20.75 20.75-2.075-2.075z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m32.163 30.088-2.075 2.075-20.75-20.75 2.075-2.075z"
  })));
};

export { SvgClose as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTAwJSIgaGVpZ2h0PSIxMDAlIiB2aWV3Qm94PSIwIDAgNDIgNDIiIGZpbGw9ImN1cnJlbnRDb2xvciIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHJlY3QgeD0iMzAuMDg3NCIgeT0iOS4zMzc0NiIgd2lkdGg9IjIuOTM0NDkiIGhlaWdodD0iMjkuMzQ0OSIgdHJhbnNmb3JtPSJyb3RhdGUoNDUgMzAuMDg3NCA5LjMzNzQ2KSIgZmlsbD0iY3VycmVudENvbG9yIi8+CjxyZWN0IHg9IjMyLjE2MjYiIHk9IjMwLjA4NzUiIHdpZHRoPSIyLjkzNDQ5IiBoZWlnaHQ9IjI5LjM0NDkiIHRyYW5zZm9ybT0icm90YXRlKDEzNSAzMi4xNjI2IDMwLjA4NzUpIiBmaWxsPSJjdXJyZW50Q29sb3IiLz4KPC9zdmc+Cg==";